import {alpha, Box, styled} from "@mui/material";

const ButtonWrapper = styled(Box)(({theme}) => ({
    width: 100,
    height: 100,
    display: "flex",
    borderRadius: "50%",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor:
        theme.palette.mode === "light"
            ? theme.palette.secondary[200]
            : alpha(theme.palette.primary[100], 0.1),
}))

export default ButtonWrapper